import React, { useState } from "react";
import { Ticket, ChevronDown, X } from "lucide-react";

/**
 * Campo Codice Lotteria scontrini.
 * Mostra un pulsante che si espande. 8 char alfanumerici uppercase (validati lato BE).
 */
export default function LotteryCodeInput({ value, onChange, testid = "lottery-input" }) {
  const [open, setOpen] = useState(!!value);
  const valid = !value || /^[A-Z0-9]{8}$/i.test(value);
  return (
    <div className="border border-velta-border rounded-md overflow-hidden">
      <button
        type="button"
        data-testid={`${testid}-toggle`}
        onClick={() => { setOpen(!open); if (open) onChange(""); }}
        className="w-full flex items-center justify-between px-3 h-11 bg-velta-bg text-sm font-medium hover:bg-velta-bg/70"
      >
        <span className="inline-flex items-center gap-2">
          <Ticket className="w-4 h-4 text-[#2F9E77]" />
          Codice Lotteria scontrini {value && <span className="font-mono text-velta-mute">({value})</span>}
        </span>
        <ChevronDown className={`w-4 h-4 text-velta-mute transition ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="p-3 border-t border-velta-border space-y-2">
          <div className="relative">
            <input
              data-testid={testid}
              type="text"
              maxLength={8}
              value={value}
              onChange={(e) => onChange(e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ''))}
              placeholder="AB12CD34"
              className={`w-full h-12 px-3 pr-10 border rounded-md font-mono font-bold text-xl tracking-[0.3em] uppercase outline-none ${value && !valid ? "border-velta-error" : "border-velta-border focus:border-[#2F9E77]"}`}
            />
            {value && (
              <button onClick={() => onChange("")} type="button" data-testid={`${testid}-clear`} className="absolute right-2 top-1/2 -translate-y-1/2 text-velta-mute hover:text-velta-error">
                <X className="w-4 h-4" />
              </button>
            )}
          </div>
          <div className="text-[10px] text-velta-mute">
            8 caratteri alfanumerici. Visibile sull&apos;app Lotteria Italia del cliente.
          </div>
        </div>
      )}
    </div>
  );
}
